import { Purpose } from '@axo/shared/data-access/types';
import { useAxoFormContext } from '../../../../../context/AxoForm/AxoForm';
import type { DenmarkFormData } from '../../FormData.dk.types';
import { PurposeFormGroup } from '../PurposeFormGroup';

export const FallbackPurposeFormGroup = () => {
  const { axoFormData } = useAxoFormContext<DenmarkFormData>();

  const initialPurpose = axoFormData['LoanApplication/InitialPurpose'];
  const totalRefinanceAmount =
    axoFormData['LoanApplication/TotalRefinancingAmount'];

  if (totalRefinanceAmount && totalRefinanceAmount > 0) return null;

  if (initialPurpose === Purpose.RefinancingLoan && totalRefinanceAmount === 0)
    return <PurposeFormGroup />;

  if (!initialPurpose) return <PurposeFormGroup />;

  return null;
};
